import React from "react";
import InterestFormCard from "./InterestFormCard";

const InterestCards = ({ items }) => {
  return (
    <div className="interest-form-grid">
      {items.map((item) => {
        return <InterestFormCard info={item} />;
      })}
    </div>
  );
};

export default InterestCards;
